import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "./SimplePresentationRunner";
import {FlightMode} from "../FlightMode";
import {gsap} from "gsap";
import {FlightModeSymbol} from "../objects/FlightModeSymbol";

export class ExplodeMultipliers implements SimplePresentation {

    shouldRun(): boolean {
        return FlightMode.model.responseWin == 0 &&
               FlightMode.model.bombPositions()[0].length == 0 &&
               (FlightMode.model.multiplierSymbolPositions().length > 0 ||
                FlightMode.model.goldenMultiplierPositions().length > 0)
    }

    public start(controller:SimplePresentationRunnerController):void {
        const tl:gsap.core.Timeline = gsap.timeline();

        const explodingPositions = FlightMode.model.allMultiplierPositions();
        const avalanchedPositions:string[][] = [
            ["", "", "", ""],
            ["", "", "", ""],
            ["", "", "", ""],
            ["", "", "", ""],
            ["", "", "", ""],
            ["", "", "", ""],
        ];

        tl.add(() => {
            FlightMode.soundPlayer.playSound("winExplode");
        })
        explodingPositions.forEach((pos) => {
            const reel = pos.reel;
            const row = pos.row;
            avalanchedPositions[reel][row] = "AV";
            tl.add(FlightMode.reelView.moveUpSymbolAt(reel, row), '<')
            tl.add(FlightMode.reelView.getSymbolAt(reel, row).explode(), '<')
            tl.add(FlightMode.reelView.moveDownSymbolAt(reel, row), '<')
        })
        tl.add(() => {});

        const obamna = avalanchedPositions.map((reel) => reel.map((row) => row == "AV"));
        tl.add(FlightMode.reelView.applyGravity(obamna), '>-0.4');
        tl.add(FlightMode.reelView.updateMultiplierCounter(1), '>');

        tl.add(() => {
            controller.finish();
        }, '>-0.2')

        tl.add(() => {
            controller.setSkipCallback(() => { tl.progress(1, false) })
        }, 0.1);
    }
}
